import { useEffect } from "react";

function setTag(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function useSeo({ title, description, image, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      setTag("name", "description", description);
      setTag("property", "og:description", description);
      setTag("name", "twitter:description", description);
    }
    if (title) {
      setTag("property", "og:title", title);
      setTag("name", "twitter:title", title);
      setTag("property", "og:type", "website");
      setTag("property", "og:site_name", "Unicorn Valley Group");
      setTag("name", "twitter:card", "summary_large_image");
    }
    if (image) {
      setTag("property", "og:image", image);
      setTag("name", "twitter:image", image);
    }
    setCanonical(window.location.href);

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      if (script && script.parentNode) script.parentNode.removeChild(script);
      document.title = "Unicorn Valley Group — China Sourcing & Global Trade";
    };
  }, [title, description, image, jsonLd]);
}
